import { useState } from 'react'
import { SlOptions } from 'react-icons/sl'
import ModalRequestsOptions from './ModalRequestsOptions'

export default function ButtonRequestsOptions({ request }) {
  const [isOpen, setIsOpen] = useState(false)

  function handleOnOpenModel() {
    setIsOpen(true)
  }

  function handleOnCloseModel() {
    setIsOpen(false)
  }
  return (
    <>
      <button
        onClick={handleOnOpenModel}
        className="p-2 bg-white border-2 border-muted-500 hover:bg-muted-500"
      >
        <SlOptions size={16} />
      </button>
      <ModalRequestsOptions
        isOpen={isOpen}
        onClose={handleOnCloseModel}
        request={request}
      />
    </>
  )
}
